import { OnboardingDataLayer } from "../lib/OnboardingDataLayer"

export const onboardingDataLayer = new OnboardingDataLayer()
